import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const SkillsSection = () => {
  const [skillsData, setSkillsData] = useState(null);
  const skillsRef = useRef(null);

  useEffect(() => {
    // Local data replacing the remote API call
    const localSkillsData = [
      {
        "title": "Crafting Unique Skills",
        "items": [
          {
            "icon": "bi bi-app-indicator",
            "value": "3+",
            "label": "years of experience",
            "description": "Worked with a diverse range of businesses, from startups to established brands, to deliver innovative web solutions."
          },
          {
            "icon": "bi bi-layers-half",
            "value": "100+",
            "label": "clients worldwide",
            "description": "Successfully collaborated with clients globally, helping them enhance their online presence and achieve their digital objectives."
          },
          {
            "icon": "bi bi-intersect",
            "value": "40+",
            "label": "projects launched",
            "description": "Delivered high-quality projects on time, focusing on user experience and effective functionality throughout the development process." 
          },
          {
            "icon": "bi bi-check2-circle",
            "value": "94%",
            "label": "Client satisfaction rate",
            "description": "Committed to maintaining a high standard in web development, ensuring that every project meets client expectations and industry standards." 
          }
        ]
        
      }
    ];

    // Simulate setting the local data like the API would
    setSkillsData(localSkillsData);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const progressBars = document.querySelectorAll('.progress-bar');
            progressBars.forEach(progressBar => {
              const value = progressBar.getAttribute('data-progress');
              progressBar.style.opacity = 1;
              progressBar.style.width = `${value}%`;
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    if (skillsRef.current) {
      observer.observe(skillsRef.current);
    }

    return () => {
      if (skillsRef.current) {
        observer.unobserve(skillsRef.current);
      }
    };
  }, [skillsData]);

  if (!skillsData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="row justify-content-between" ref={skillsRef}>
      <div className="col-12 col-lg-3">
        <div className="intro">
          <h3 className="title">{skillsData[0].title}</h3>
        </div>
      </div>
      <div className="col-12 col-lg-8">
        <div className="row items">
          {skillsData[0].items.map((item, index) => (
            <div key={index} className="col-12 col-md-6 item">
              <div className="content">
                <div className="heading d-flex align-items-center">
                  <i className={`icon ${item.icon}`}></i>
                  <h2 className="title m-0 ms-2">{item.value}</h2>
                </div>
                <span>{item.label}</span>
                <p className="mt-3">{item.description}</p>
              </div>
            </div>
          ))}
          
        </div>
      </div>
    </div>
  );
};

export default SkillsSection;
